// Access to the vendored compiled design-system bundle.
//
// The design system exists only as a compiled bundle (not as TSX source), so it is loaded for its
// side effect and read back off the global namespace it attaches. Everything that touches that
// namespace lives here; `index.ts` is the public surface and `localised.tsx` adapts individual
// components to the operator's language, and both go through `cmp()`.
//
// IMPORT ORDER MATTERS: setup-globals (exposes window.React) must evaluate before the bundle.
import "./setup-globals";
import "./vendor/ds-bundle.js";

import type * as React from "react";
import { PRODUCT_NAME } from "../../../product-name";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const NS = window.NEOCockpitDesignSystem_04cf2b as Record<string, any>;

if (!NS || typeof NS !== "object") {
  throw new Error(
    `${PRODUCT_NAME} design-system bundle did not initialise: ` +
      "window.NEOCockpitDesignSystem_04cf2b is missing. " +
      "Check that src/ds/vendor/ds-bundle.js loaded after window.React was set.",
  );
}

/**
 * Props for the vendored DS components are intentionally permissive (the bundle is the source of
 * truth, not these types). Common props are named for ergonomics; the index signature accepts the
 * rest. Components whose values are load-bearing — a button's variant, an alert's tone — declare
 * those props explicitly on top of this, and a declared prop is checked rather than swallowed by
 * the index signature.
 */
export type DSProps = {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [prop: string]: any;
};

export type DSComponent<P = DSProps> = React.FC<P>;

export function cmp<P = DSProps>(name: string): DSComponent<P> {
  const c = NS[name];
  if (!c) {
    // Surfaces a missing-export early instead of rendering `undefined`.
    throw new Error(
      `${PRODUCT_NAME} design-system: component "${name}" is not exported by the bundle.`,
    );
  }
  return c as DSComponent<P>;
}
